export default __webpack_public_path__ + "static/media/notification.c7957132.png";